import type { PhysicalHorizontalDirection, ScrollPosition, TextDirection } from 'LuxKit/Carousel/utils'
import { isPhysicalHorizontalArrowHidden } from 'LuxKit/Carousel/utils'

/**
 * Hide controls until a synchronous layout measurement confirms overflow. This avoids treating
 * an unscrollable table only as the logical start, which would leave the forward arrow visible.
 */
export function isTripOptionsTableScrollArrowHidden(
  hasHorizontalOverflow: boolean | undefined,
  scrollPosition: ScrollPosition,
  textDirection: TextDirection,
  physicalDirection: PhysicalHorizontalDirection,
): boolean {
  return !hasHorizontalOverflow ||
    isPhysicalHorizontalArrowHidden(scrollPosition, textDirection, physicalDirection)
}
